//Enums for global status
export const GLOBAL_STATUS = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  NO_CONTENT: 204,
  NON_AUTHORITATIVE: 203,
  BAD_REQUEST: 400,
};

//Enums for screen id
export const SCREENS_IDS = {
  DASHBOARD: 1,
  USERS: 2,
  EMPLOYEES: 6,
  SETTINGS: 10,
  ATTENDANCE: 11,
  CAN_CREATE_USER: 3,
  CAN_EDIT_USER:4,
  CAN_DELETE_USER:5,
  CAN_CREATE_EMPLOYEE: 7,
  CAN_EDIT_EMPLOYEE:8,
  CAN_DELETE_EMPLOYEE:9,
  EMPLOYEE_ATTENDANCE: 12,
  PLATFORM_DASHBOARD: 100,
  COMPANIES: 101,
};

//Constants for report parameters
export class ReportParameters {
  startDate;
  endDate;
  restaurantId;
  reportType;
}

//Enums for report type
export const reportTypeEnum = {
  ConversionReport: 1,
  TriggerEventReport: 2,
};

//Enum for unsubscribe contacts
export const unsubscribeContactTypeEnum = {
  1: "Email",
  2: "Phone",
};

//Request for the paginated post body
export class PaginatedPostRequestBody {
  constructor(pagination, pageNumber, searchStr, sortBy, filter) {
    //Use the page number from params or get it from redux pagination state
    this.pageNumber =
      pageNumber !== null && pageNumber >= 0
        ? pageNumber
        : pagination.pageNumber + 1;
    this.length = pagination.pageSize;
    this.search = searchStr;
    this.orderBy = sortBy.id;
    this.orderByDirection = sortBy.desc ? "desc" : "asc";
    this.filter = filter;
  }
}

//Enum for platform
export const orderSourceTypeEnums = {
  ninefold: "1",
  hungerRush: "2",
  menufy: "3",
};

//Enums for rule groups
export const ruleGroupEnum = ["none", "Income", "Reminder", "REST", "Imported"];

//Enums for reference type
export const referenceTypeEnum = ["none", "Cumulative", "Date", "Rule"];

//Enums for condition type
export const conditionTypeEnum = [
  "none",
  "Amount",
  "Quantity",
  "CumulativeAmount",
  "LastOrderPeriod",
];

//Enums for condition type id
export const conditionTypeIdEnum = {
  INCOMING_EVENT: 1,
  CONDITION_IS_MET: 2,
  REST: 3,
  CUSTOMER_IMPORTED: 4,
};

//Enums for condition type id
export const conditionTypeIdEnumForSurvey = {
  POSITIVE: 5,
  NEGATIVE: 6,
  PASSIVE: 7,
};

//Enums for delivery group
export const deliveryGroupEnums = {
  MARKETING: "1",
  SURVEY: "2",
};

//Enums for delay type
export const delayTypeEnums = {
  POSTPONE: 1,
  APPOINTMENT: 2,
  DATE: 3,
  RELATIVE_POSTPONE: 4,
  DAYS_OF_WEEK: 5,
};

//Enums for delay type
export const couponCheckboxEnums = {
  EXPIRE_COUPON: "isExpireCoupon",
  REDEEM_NEW_COUPON: "redeemNewCoupon",
};

export const deliveryType = {
  EMAIL: 3,
  SMS: 4,
};

export const lifeSpanUnit = {
  DAYS: "d",
  HOURS: "h",
  MINUTES: "m",
};

//Enums for condition Types
export const conditionTypesIdEnum = {
  CODE: 1,
  EXPRESSION: 2,
};

export const deliveryTypeValues = {
  EMAIL: "Email",
  SMS: "SMS",
};

// Campaign Flow Condition Type
export const conditionTypeValues = {
  ConditionCumulativeAmount: "CumulativeAmountCandidates",
  ConditionLastOrderPeriod: "CustomerLastOrderRemainderCandidates",
  ConditionQuantity: "QuantityCandidates",
};
